import { gql } from "@apollo/client";
import { ReportTemplate } from "../../../../Definitions";
import { REPORT_FILTER_FRAGMENT } from "./getArchivedReportsCall";

export const REPORT_TEMPLATE_FRAGMENT = gql`
  fragment ReportTemplateFields on ReportTemplate {
    templateId: report_template_id
    name
    dataLevel: data_level
    filterParameter: filter {
      ...FilterFields
    }
    shouldArchive: should_archive
  }
${REPORT_FILTER_FRAGMENT}
`

export const GET_REPORT_TEMPLATE = gql`
  query Template($domain: String!, $input: BasicQueryInfoInput!) {
    report {
      template(domain: $domain, input: $input) {
        ...ReportTemplateFields
      }
    }
  }
  ${REPORT_TEMPLATE_FRAGMENT}
`

 
export interface ReportTemplateResponse {
  report: {
    template: ReportTemplate
  }
}
